import {useMemo} from 'react';
import {useRepair} from '../context/repair-context';
import FixtLogo from '../logo.svg';
import PrintButton from '../components/print-button';

const determineLogosByPriority = (accountLogo: string, groupLogo: string) => {
  const logos = [
    {alt: 'Group Logo', image: groupLogo, priority: 1},
    {alt: 'Account Logo', image: accountLogo, priority: 2},
    {alt: 'Fixt Logo', image: FixtLogo, priority: 3},
  ];

  const sortedLogoComponents = logos
    .filter((logo) => logo.image)
    .sort((a, b) => a.priority - b.priority)
    .map((logo) => <img className="h-full" data-testid="logo" alt={logo.alt} key={logo.alt} src={logo.image} />);

  return [...sortedLogoComponents, null];
};

export const Header = () => {
  const {group, repair} = useRepair();
  const {logo: groupLogo, accountLogo, trackingIntakeEnabled, trackingReleaseEnabled} = group;
  const [logo] = useMemo(() => determineLogosByPriority(accountLogo, groupLogo), [accountLogo, groupLogo]);
  const displayPrintRelease = trackingReleaseEnabled && repair?.repairState === 'completed';

  return (
    <div className="h-20 border-b border-border py-4 px-8 lg:px-24">
      <div className="flex h-full justify-between items-center">
        <div className="h-full">{logo}</div>
        <PrintButton
          printIntakeEnabled={trackingIntakeEnabled}
          printReleaseEnabled={displayPrintRelease}
          claimId={repair?.id}
        />
      </div>
    </div>
  );
};
